import { Injectable } from '@angular/core'
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'

@Injectable()

export class PublicGuard implements CanActivate {

    constructor(private router: Router) { }
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // if (localStorage.getItem('user') && localStorage.getItem('user') !== 'undefined') {
        //     console.log("inside 1")
        //     this.router.navigate(['users/login']);
        //     return false;
        // }
        // else{
        //     console.log("inside 2")
        //     return true;
        // }
        return true;
        
    }
}
